import { BELGE_TURU_VE_DURUMUNA_GORE_BASVURU_LISTESI } from "../constants/requestUrls";
import { postRequest } from "../request";

const belgeTuruVeDurumunaGoreBasvuruListesi = (BelgeGrubuId,belgeTuruId, BasvuruAnaDurumId) => {
    var BelgeTuruId = [];
    if(belgeTuruId !=null || belgeTuruId !==undefined)
    {
    BelgeTuruId.push(belgeTuruId);
    }
    let data = {BelgeTuruId, BasvuruAnaDurumId,BelgeGrubuId};
    data =JSON.stringify(data);
  
    return postRequest({url:BELGE_TURU_VE_DURUMUNA_GORE_BASVURU_LISTESI,data});
}

export default belgeTuruVeDurumunaGoreBasvuruListesi;